import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';

import VideoModal from './VideoModal';
import { colors } from '../styles';

const styles = css`
  .VideoList_item {
    @media(min-width: 992px) {
      margin-bottom: 40px;
    }
  }
  .VideoItem_wrapper {
    padding-top: 56.25%;
    margin-bottom: 20px;
    cursor: pointer;
    position: relative;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
    margin: 0 auto;
    transition: all .3s ease-out;
    @media(min-width: 768px) {
      margin: 10px 15px;
    }
    &:focus {
      outline: none;
    }
    &:hover {
      background-size: 102%;
      transition: all .3s ease-out;
      .Video_overlay {
        background-color: rgba(0, 0, 0, 0.4);
        transition: all .3s ease-out;
        img {
          height: 41px;
          opacity: .8;
          transition: all .3s ease-out;
        }
      }
    }
  }
  .VideoItem_wrapperAlt {
    @media(min-width: 992px) {
      width: 870px;
      height: 489px;
      .Video_overlay {
        height: 100%;
        transition: all .3s ease-out;
      }
    }
  }
  .Video_overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(51,51,51,0.1);
    top: 0;
    margin: 0 !important;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    box-shadow: inset 0 5px 20px rgba(51, 51, 51, 0.39);
    transition: all .3s ease-out;
    img {
      opacity: 1;
      height: 38px;
      transition: all .3s ease;
    }
  }
  .VideoList_btnWrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 50px;
    flex-direction: column;
    align-items: center;
  }
  .VideoList_btn {
    background-color: ${colors.color1};
    box-shadow: 0 9px 15px 0 rgba(0,0,0,0.15);
    border-radius: 9px;
    height: 60px;
    width: 265px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 14px;
    color: #FFFFFF;
    letter-spacing: 2px;
    text-align: center;
    line-height: 14px;
    text-transform: uppercase;
    transition: all .3s ease-out;
    cursor: pointer;
    &:hover {
      background-color: ${colors.color2};
    }
    &:focus {
      outline: none;
    }
  }
  .VideoItem_description {
    font-weight: 300;
    font-size: 18px;
    color: #212121;
    letter-spacing: 0;
    line-height: 38px;
    padding: 0 15px;
    @media(min-width: 768px) {
      width: 570px;
      display: flex;
    }
  }

  .ContactModal_wrapper {
    padding: 0 15px;
  }
  .VideoItem_title {
    font-size: 14px;
    color: #000000;
    letter-spacing: 0;
    line-height: 35px;
    text-transform: uppercase;
    margin-top: 20px;
    font-weight: 300;
    @media(min-width: 992px) {
      margin:28px 15px;
      font-size: 14px;
      letter-spacing: 3.07px;
      line-height: 20px;
    }
    .VideoItem_name{
      font-weight: 700;
    }
  }

`;

function VideoList({ video, thumb, name, title, description, oneVideo }) {
  return (
    <div className={styles}>
      <VideoModal
        video={video}
        thumb={thumb}
      >
        <div
          className={`VideoItem_wrapper ${oneVideo ? 'VideoItem_wrapperAlt' : ''}`}
          style={{ backgroundImage: `url(${buildThumbnailUrl(thumb, { width: 1200, height: 1200, preserve: true })})` }}
          role="button"
          tabIndex="0"
        >
          <div className="Video_overlay">
            <img src="/images/icons/play-btn-white.svg" alt="Play Icon" />
          </div>
        </div>
        {
          title &&
          <h4 className="VideoItem_title"><span className="VideoItem_name">{name}</span> {title ? `| ${title}` : ''}</h4>
        }
        {
          description &&
          <span className="VideoItem_description">{description}</span>
        }
      </VideoModal>
    </div>
  );
}

VideoList.propTypes = {
  description: PropTypes.string,
  name: PropTypes.string,
  title: PropTypes.string,
  thumb: PropTypes.string,
  video: PropTypes.string,
  oneVideo: PropTypes.bool,
};

VideoList.defaultProps = {
  description: undefined,
  name: undefined,
  title: undefined,
  thumb: undefined,
  video: undefined,
  oneVideo: false,
};

export default VideoList;



// WEBPACK FOOTER //
// ./src/components/VideoList.js